// Cache the result to avoid repeated URL parsing
let cachedProductReferer: string | null = null;
let isInitialized = false;

/**
 * Checks if utm_medium=chrome-extension exists in URL query params
 * and caches the result for the session.
 */
function initializeProductReferer(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const utmMedium = urlParams.get('utm_medium');

  if (utmMedium === 'chrome-extension') {
    cachedProductReferer = 'paperpal-edit-for-extension';
  }

  isInitialized = true;
}

/**
 * Returns the x-product-referer header value if applicable.
 * Caches the result on first call for performance.
 */
export function getProductRefererHeader(): Record<string, string> {
  if (!isInitialized) {
    initializeProductReferer();
  }

  if (cachedProductReferer) {
    return {
      'x-product-referer': cachedProductReferer,
    };
  }

  return {};
}

/**
 * Checks if a URL matches one of the API endpoints that should include
 * the x-product-referer header.
 */
export function shouldAddProductRefererHeader(url: string): boolean {
  const targetEndpoints = [
    '/api/v1/chat-pdf/sse',
    '/api/v2/chat-pdf/sse',
    '/api/v4/text/generation/research',
  ];

  return targetEndpoints.some((endpoint) => url.includes(endpoint));
}
